import React,{ChangeEvent, useCallback} from "react";
import MembOtpRegChkApi from "Apis/MembOtpRegChkApi";
import { useEffect, useState } from "react";
import { useOutletContext  ,useLocation,useNavigate} from "react-router-dom";
import MdalCommUi from "Utils/MdalCommUi";
import MembOtpRegApi from "Apis/MembOtpRegApi";
import MgpStore from "Stores/Store";
import MembEmlAddrChngApi from "Apis/MembEmlAddrChngApi";
import MembMktgAgreInqApi from "Apis/MembMktgAgreInqApi";
import { Helmet } from "react-helmet-async";
import TrmsCtxtInqApi from "Apis/TrmsCtxtInqApi";
import sanitizeHtml from 'sanitize-html';

import ApiResultModal from "Components/ApiResultModal";
import { isMobile } from "react-device-detect";
import EmlAthnModalUi from "Utils/EmlAthnModalUi";


const MembEmlChngInputUi = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const langData:any = useOutletContext();
    const [otpAthnNo,setotpAthnNo] = useState("");
    const [mdalCtxtTitlState,setMdalCtxtTitlState] = useState("");
    const [mktgTrmsContent,setMktgTrmsContent] = useState(""); // 마케팅 약관 내용 저장
    const [emlAthnState,setEmlAthnState] = useState("N");
    const[emlInputState,setEmlInputState] = useState("");
    const [showEmlModal, setShowEmlModal] = useState(false);
    const [emlNtfyRecvYn,setEmlNtfyRecvYn] = useState("N");
    const [resultModalOpen, setResultModalOpen] = useState(false);
    const [resultModalMessage, setResultModalMessage] = useState("");
    const [modalAction, setModalAction] = useState<(() => void) | null>(null);

    const openResultModal = (message: string, onClose?: () => void) => {
        setResultModalMessage(message);
        setModalAction(() => onClose || null);
        setResultModalOpen(true);
    };

    const closeResultModal = () => {
        setResultModalOpen(false);
        const action = modalAction;
        setModalAction(null);
        if (action) action();
    };
    var popupX = Math.round(window.screenX + (window.outerWidth/2) - (500/2));
    var popupY = Math.round(window.screenY + (window.outerHeight/2) - (670/2));
    const EmlAthnPopFunc = (e:any)=>{
        if (isMobile) {
            setShowEmlModal(true);
        } else {
            window.open(e,"_blank","width=550,height=800 left="+popupX+"top="+popupY);
        }
    }
    const [mdalState,setmdalState] = useState(false);
    const mdalOpener = useCallback((e:string|null)=> {
        if(e != null) {
            setMdalCtxtTitlState(e);
        }
        setmdalState(!mdalState);
    },[mdalState,setmdalState]);
    const EmlChngFunc =() => {
        MembEmlAddrChngApi(emlInputState,emlNtfyRecvYn).then((resp)=>{
            if(resp.apiHdr.code == "MEMB0000") {
                openResultModal(
                    `${langData&&langData.GLB_DATA_CHNG_SCSS_DESC_00}`,
                    () => navigate("/MyPage")
                );
            }else {
                openResultModal(`${langData&&langData.GLB_API_FAIL_DESC_00} ${resp.apiBody.param} ${resp.apiBody.nowDtime}`)
            }
        })
    }
    const AgreEmlNtfyFunc = (e:ChangeEvent<HTMLInputElement>) => {

            if(e.target.checked) {
                setEmlNtfyRecvYn("Y");
            }else {
                setEmlNtfyRecvYn("N");
            }

    }
    useEffect(()=>{
        MembMktgAgreInqApi()
        .then((resp) => {
            setEmlNtfyRecvYn(resp.apiBody.emlNtfyRecvYn);
        });
        const emlAthnRespFunc =(athnPrpsCd:string,membEml:string) => {
            setEmlAthnState("Y");
            setEmlInputState(membEml);
            setShowEmlModal(false);
        }
        window.emlAthnRespFunc = emlAthnRespFunc;
        TrmsCtxtInqApi("CTNT_KIND_TRMS","TRMS_MKTG",null)
        .then((Resp) => {
            const dirty = Resp.apiBody.trmsCtxt;
            const sanitizedContent = sanitizeHtml(dirty,{
                
            });
            setMktgTrmsContent(sanitizedContent);
        });
},[])
    return(
        <>
        <ApiResultModal
            open={resultModalOpen}
            message={resultModalMessage}
            onClose={closeResultModal}
confirmText={langData&&langData.COMM_MAIN_CHK_MAIN_BTN_00}
        />
        <Helmet>
            <title>{`${process.env.REACT_APP_TITLE_PREFIX} ${langData&&langData.MYPAGE_MENU_EML_CHNG_BTN_00}`}</title>
        </Helmet>
        <div className="container1300 BgW pb200">
            <div className="myPageSubTitlWrap">
                <p className="myPageCtxtTitl">{langData&&langData.MYPAGE_MENU_EML_CHNG_BTN_00}</p>
            </div>
            {/* OTP 설정 */}
            <div className="container640">
                <div className="emlInputWrap">
                    <div className="emlInputLi">
                        <div className="emlInputLbl">
                            <p>{langData&&langData.MYPAGE_EML_CHNG_INPUT_LBL_00}</p>
                            {/* 이메일 */}
                        </div>
                        <div className="inputWrap">
                            
                            {emlAthnState ==="N"?
                                <>
                                <input type="text" placeholder={`${langData&&langData.MYPAGE_EML_CHNG_INPUT_DESC_00}`} value={emlInputState} readOnly onClick={() => EmlAthnPopFunc(`${'/EmlAthnPop?emlAthnPrpsCd=EML_CHNG' + "&lang=" +MgpStore.getState().LangSetState.Lang}`)}/>
                                <button onClick={() => EmlAthnPopFunc(`${'/EmlAthnPop?emlAthnPrpsCd=EML_CHNG' + "&lang=" +MgpStore.getState().LangSetState.Lang}`)}>
                                    <p>{langData&&langData.COMM_MAIN_ATHN_MAIN_BTN_00}</p>
                                </button>
                                {showEmlModal && (
                                    <EmlAthnModalUi
                                        emlAthnPrpsCd={"EML_CHNG"}
                                        onSuccess={(athnPrpsCd: string, membEml: string) => {
                                            if (typeof window.emlAthnRespFunc === 'function') {
                                                window.emlAthnRespFunc(athnPrpsCd, membEml);
                                            }
                                        }}
                                        onClose={() => setShowEmlModal(false)}
                                    />
                                )}
                                </>
                                :
                                <>
                                <input type="text" placeholder={`${langData&&langData.MYPAGE_EML_CHNG_INPUT_DESC_00}`} value={emlInputState} readOnly />
                                <div className='disableBtn'>
                                    <p>{langData&&langData.COMM_MAIN_ATHN_MAIN_BTN_01}</p>
                                </div>
                                </>

                            }
                        </div>
                    </div>
                    <div className="emlInputLi">
                        <div className="emlInputLbl">
                            <p>{langData&&langData.MYPAGE_EML_CHNG_MKTG_LBL_00}</p>
                            {/* 마케팅 동의 */}
                        </div>
                        <div className="inputWrap">
                            <div className="checkboxWrap">
                                <input type="checkbox" name='agreEmlNtfy' className='agreChkBox' id='agreEmlNtfy' checked={emlNtfyRecvYn=="Y"} onChange={AgreEmlNtfyFunc}/>
                                <label htmlFor="agreEmlNtfy">{langData&&langData.MYPAGE_EML_CHNG_MKTG_BTN_00}</label>
                            </div>
                            <button onClick={() => mdalOpener(mktgTrmsContent)}>
                                <p>{langData&&langData.MYPAGE_EML_CHNG_MKTG_LPOP_00}</p>
                            </button>
                        </div>
                    </div>
                </div>
                <div className="emlInputBtnWrap">
                    <button onClick={EmlChngFunc}>
                        <p>{langData&&langData.COMM_MAIN_CHK_MAIN_BTN_00}</p>
                    </button>
                </div>
            </div>
        </div>
        {mdalState && (
            <MdalCommUi mdalType={"modalType01"} mdalCtxtTitl={mdalCtxtTitlState} mdalSize={"w500 tCenter"} mdalFunc={()=>mdalOpener(null)} />
        )}
        </>
    )
}


export default MembEmlChngInputUi;